import { Box, Divider, makeStyles, Typography, useTheme } from '@material-ui/core';
import ChatAvatar from './ChatAvatar';
import { monochrome } from '../../theme/styles';
import { AppIconButton } from '../AppIconButton';
import { HiChevronLeft } from 'react-icons/hi';

interface Props {
  name: string;
  avatarUrl: string;
  bio?: string;
  email?: string;
  phone?: string;
  jobTitle?: string;
  onClose: () => void;
}

export const ChatUserDetails: React.FC<Props> = ({
  name,
  avatarUrl,
  bio,
  email,
  phone,
  jobTitle,
  onClose,
}) => {
  const theme = useTheme();
  const classes = useStyles({ theme });
  return (
    <Box className={classes.root}>
      <Box className={classes.headerBox}>
        <ChatAvatar
          avatarUrl={avatarUrl}
          size={48}
          chatType="private"
          borderWidth={1}
          borderColor={theme.palette.background.paper}
          online={false}
          name={name || undefined}
        />
        <Box className={classes.textBox}>
          <Typography className={classes.name}>{name}</Typography>
        </Box>

        <AppIconButton
          variant="default"
          disableFocusRipple
          disableRipple
          disableTouchRipple
          onClick={onClose}
        >
          <HiChevronLeft color={theme.palette.text.secondary} />
        </AppIconButton>
      </Box>

      <Divider />

      <Box className={classes.detailsBox}>
        <Typography className={classes.detailsTitle}>Personal Details</Typography>
        <Box className={classes.detailsColumn}>
          <Typography className={classes.label}>Email Address</Typography>
          <Typography className={classes.value}>{email || 'N/A'}</Typography>
          <Typography className={classes.label}>Phone Number</Typography>
          <Typography className={classes.value}>{phone || 'N/A'}</Typography>
        </Box>
      </Box>
    </Box>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    padding: '16px 24px',
  },
  headerBox: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 16,
  },
  textBox: {
    marginLeft: 12,
    width: '100%',
    paddingRight: 12,
    overflow: 'hidden',
  },
  name: {
    fontWeight: 600,
    fontSize: 15,
    color: theme.palette.type === 'dark' ? monochrome.light : monochrome.dark,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  detailsBox: {
    marginTop: theme.spacing(2),
  },
  detailsTitle: {
    fontWeight: 600,
    fontSize: 18,
    marginBottom: 16,
  },
  detailsColumn: {
    display: 'flex',
    flexDirection: 'column',
  },
  label: {
    fontWeight: 600,
    fontSize: 13,
    color: theme.palette.type === 'dark' ? monochrome.mediumlight : monochrome.mediumdark,
  },
  value: {
    fontSize: 14,
    marginBottom: 16,
  },
}));
